import { c as _c } from "react/compiler-runtime";
import { ImageOffIcon, LucideIcon } from 'lucide-react';
type NoImagePlaceholderProps = {
  icon?: LucideIcon;
  iconSize?: number;
  className?: string;
};
const NoImagePlaceholder = t0 => {
  const $ = _c(6);
  const {
    icon: t1,
    iconSize: t2,
    className: t3
  } = t0;
  const Icon = t1 === undefined ? ImageOffIcon : t1;
  const iconSize = t2 === undefined ? 24 : t2;
  const className = t3 === undefined ? "" : t3;
  const t4 = `bg-muted flex h-full w-full items-center justify-center ${className}`;
  const t5 = `text-muted-foreground h-${iconSize} w-${iconSize} opacity-30`;
  let t6;
  if ($[0] !== Icon || $[1] !== t5) {
    t6 = <Icon className={t5} />;
    $[0] = Icon;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t4 || $[4] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[3] = t4;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default NoImagePlaceholder;